import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

export default function EnachdauthPage() {
		const location = useLocation();
	const [pageReady, setPageReady] = useState(true);
	  const policyno = new URLSearchParams(window.location.search).get("policyno");
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [reqJson, setReqJson] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  useEffect(() => {
      const jqueryScript = document.createElement("script");
      jqueryScript.src = "https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js";
      jqueryScript.onload = () => {
          const checkoutScript = document.createElement("script");
          checkoutScript.src = "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js";
          checkoutScript.onload = () => setScriptLoaded(true);
          document.body.appendChild(checkoutScript);
      };
      document.body.appendChild(jqueryScript);
      return () => {
          if (document.body.contains(jqueryScript)) document.body.removeChild(jqueryScript);
          const checkout = document.querySelector('script[src*="checkout.js"]');
          if (checkout && document.body.contains(checkout)) document.body.removeChild(checkout);
      };
  }, []);
  useEffect(() => {
      if (!policyno) return;
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_PATH}mandate/getdenach?policyno=${policyno}`)
      .then(res => res.ok ? res.json() : Promise.reject('Failed to fetch'))
      .then(data => {
          if (data.error) throw new Error(data.error);
          data.consumerData.responseHandler = handleResponse;
          setReqJson(data);
          setStatus('Ready to authorize');
      })
      .catch(err => setStatus('Error: ' + err.message))
      .finally(() => setLoading(false));
  }, [policyno]);
  const handleResponse = (res) => {
      console.log("Response:", res);
      const statusCode = res?.paymentMethod?.paymentTransaction?.statusCode;
      if (statusCode === "0300") {
          setStatus('Success! Mandate registered');
          fetch("/api/payment/handle-response", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(res),
          });
          } else {
          setStatus('Failed: ' + (res?.paymentMethod?.paymentTransaction?.errorMessage || 'Unknown error'));
      }
  };
  const startPayment = () => {
      if (!scriptLoaded || !window.$?.pnCheckout) return alert("Scripts not loaded");
      if (!reqJson) return alert("Data not loaded");
      window.$.pnCheckout(reqJson);
      setStatus('Redirecting to payment...');
  };
	return (
		<main id="EnachdauthPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div className="">
                        <div className="col comp-grid">
                            <Title title={$t('enachauth')} titleClass="text-lg font-bold text-primary" subTitleClass="text-500" separator={false} />
                            <div>
                                <h2>eNACH Authorization</h2>
                                <p>Policy Account: {policyno || 'Not provided'}</p>
                                {status && <p style={{color: status.includes('Success') ? 'green' : status.includes('Error') ? 'red' : 'blue'}}>{status}</p>}
                                <button onClick={startPayment} disabled={!scriptLoaded || loading || !reqJson} style={{ background: "#45beaa", color: "#fff", padding: "10px 20px", border: "none", borderRadius: "8px", cursor: "pointer", opacity: (!scriptLoaded || loading || !reqJson) ? 0.5 : 1 }}>
                                {loading ? 'Loading...' : 'Start eNACH Payment'}
                                </button>
                                {reqJson?.merchantConfig && (
                                <div style={{marginTop: '10px', fontSize: '12px', color: '#666'}}>
                                    Merchant: {reqJson.merchantConfig.merchantId} | Pay ID: {reqJson.merchantConfig.payId}
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
